import React, { Component } from "react";
import { Divider, List, Tag } from "antd";
import { object, func } from "prop-types";

import { SectionHeading, Spinner } from "../";

const SUBSCRIPTION_STATUS = {
  SUBSCRIBED: "SUBSCRIBED",
  BLOCKED: "BLOCKED",
  NOT_SUBSCRIBED: "NOT_SUBSCRIBED",
  TRIAL: "TRIAL"
};

class Subscriptions extends Component {
  state = {
    subscription: {
      loading: true,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    const { appsAPI } = this.props;

    const self = this;
    appsAPI
      .get(`/subscription`)
      .then(function(response) {
        self.setState(prevState => ({
          subscription: {
            ...prevState.subscription,
            loading: false,
            //raw: response.data,
            data: Subscriptions.processSubscription(response.data)
          }
        }));
      })
      .catch(error => {
        console.log("Error occurred fetching subscription", error);
        self.setState(prevState => ({
          subscription: {
            ...prevState.subscription,
            error: true,
            loading: false,
            errorMsg: error.message
          }
        }));
      });
  }

  static processSubscription(data) {
    let processed = {};
    data.forEach(item => {
      const groupName = item.app_group_name;
      if (!processed[groupName]) processed[groupName] = [];
      processed[groupName].push(item);
    });

    return processed;
  }

  static getColorByStatus(status) {
    switch (status) {
      case SUBSCRIPTION_STATUS.SUBSCRIBED:
        return "green";
      case SUBSCRIPTION_STATUS.NOT_SUBSCRIBED:
        return "gray";
      case SUBSCRIPTION_STATUS.TRIAL:
        return "blue";
      case SUBSCRIPTION_STATUS.BLOCKED:
        return "red";
      default:
        return "black";
    }
  }

  static isSignUpAllowed(status) {
    return status === SUBSCRIPTION_STATUS.NOT_SUBSCRIBED;
  }

  static isAppAccessAllowed(status) {
    return (
      status === SUBSCRIPTION_STATUS.SUBSCRIBED ||
      status === SUBSCRIPTION_STATUS.TRIAL
    );
  }

  render() {
    const { style } = this.props;
    const { subscription } = this.state;
    return (
      <div style={style}>
        <SectionHeading title="Apps subscriptions" icon="appstore" />
        {subscription.loading && (
          <Spinner loading="Loading subscription information" />
        )}
        {subscription.error && <div>Error: {subscription.errorMsg}</div>}
        {subscription.data &&
          Object.keys(subscription.data).map(ag => (
            <div style={{ padding: "0 8px" }} key={ag}>
              <Divider orientation="left">{ag}</Divider>
              <List itemLayout="horizontal">
                {subscription.data[ag].map(a => (
                  <List.Item
                    key={a.app_name}
                    actions={[
                      <a
                        disabled={
                          !Subscriptions.isAppAccessAllowed(
                            a.subscription_status
                          )
                        }
                        href={a.app_url}
                      >
                        visit app
                      </a>,
                      <a
                        disabled={
                          !Subscriptions.isSignUpAllowed(a.subscription_status)
                        }
                        href={`${a.app_url}/requesttrial`}
                      >
                        request trial
                      </a>
                    ]}
                  >
                    <List.Item.Meta
                      title={
                        <b>
                          <a href={a.app_url}>{a.app_name}</a>
                        </b>
                      }
                      description={a.app_description}
                    />
                    <div>
                      <Tag
                        color={Subscriptions.getColorByStatus(
                          a.subscription_status
                        )}
                      >
                        {a.subscription_status}
                      </Tag>
                    </div>
                  </List.Item>
                ))}
              </List>
            </div>
          ))}
      </div>
    );
  }
}

Subscriptions.propTypes = {
  style: object,
  appsAPI: func.isRequired
};

export default Subscriptions;



// WEBPACK FOOTER //
// ./src/components/subscriptions/Subscriptions.jsx